export { TinRegistration } from './TinRegistration';
